import React from 'react';
import styles from './InputCheckbox.module.scss';

interface InputCheckboxProps {
  htmlId: string,
  name?: string,
  checked?: boolean,
  onChange?: (checked: boolean) => void,
  label: string | React.ReactNode,
  disabled?: boolean,
}

export function InputCheckbox(props: InputCheckboxProps) {
  return (
    <div className={ styles.container }>
      <input
        type="checkbox"
        id={ props.htmlId }
        data-type={ props.htmlId }
        name={ props.name }
        checked={ props.checked }
        onChange={ (e) => props.onChange ? props.onChange(e.target.checked) : undefined }
        disabled={ props.disabled }
        className={ styles.input }
      />
      <label htmlFor={ props.htmlId } className={ styles.label }>
        <span>{ props.label }</span>
      </label>
    </div>
  );
}
